import React, {useEffect, useRef } from 'react';
import Utils from '../utils';

function SkillResult({ item, index, term, useRaw }) {

    const componentRef = useRef(null);
    
    useEffect(() => {
        // Run doCH for the current component only
        if (componentRef.current) {
          Utils.highlightSearchTerm(componentRef.current, term);
          Utils.doCH(componentRef.current);
        }
      }, [term]); // Empty dependency array ensures this runs only once after initial render

  return (
    <li className={`result-item ${item.outputLanguage2 ? `multi` : ``}`} data-id={item.skill_id} key={index} ref={componentRef}>
        <ul className="info-container" data-id={item.skill_id}>
            <li>
                <span>{item.skill_id} - Lv. {item.level}</span>
            </li>
        </ul>
        <ul className="language-container" data-id={item.skill_id}>
            <li>
                {item.sublevel > 0 ? (
                <span className="sublevel">+{item.sublevel - 1000} </span>
                ) : null}
                <strong>
                <span className="copyable skill_name">{item.inputLanguage.name}</span> <span className='add_name'>{Utils.getLvString(item.inputLanguage.lang, item.level)}</span>
                </strong>
                <br />
                <br />
                {useRaw ? (
                    <span
                    className={Utils.getDescClass(item.inputLanguage.desc)}
                    >{item.inputLanguage.desc}</span>
                    ) : (
                <span
                className={Utils.getDescClass(item.inputLanguage.desc)}
                dangerouslySetInnerHTML={{
                    __html: Utils.doPreview(item.inputLanguage.desc),
                }}
                ></span>
                )}
            </li>
        </ul>
        <ul className="language-container" data-id={item.skill_id}>
            <li>
                {item.sublevel > 0 ? (
                <span className="sublevel">+{item.sublevel - 1000} </span>
                ) : null}
                <strong>
                <span className="copyable skill_name">{item.outputLanguage.name}</span> <span className='add_name'>{Utils.getLvString(item.outputLanguage.lang, item.level)}</span>
                </strong>
                <br />
                <br />
                {useRaw ? (
                    <span
                    className={Utils.getDescClass(item.outputLanguage.desc)}
                    >{item.outputLanguage.desc}</span>
                    ) : (
                <span
                className={Utils.getDescClass(item.outputLanguage.desc)}
                dangerouslySetInnerHTML={{
                    __html: Utils.doPreview(item.outputLanguage.desc),
                }}
                ></span>
                )}
            </li>
        </ul>
        {/* Check if item has outputLanguage2 */}
        {item.outputLanguage2 ? (
          <ul className="language-container" data-id={item.skill_id}>
          <li>
              {item.sublevel > 0 ? (
              <span className="sublevel">+{item.sublevel - 1000} </span>
              ) : null}
              <strong>
              <span className="copyable skill_name">{item.outputLanguage2.name}</span> <span className='add_name'>{Utils.getLvString(item.outputLanguage2.lang, item.level)}</span>
              </strong>
              <br />
              <br />
                {useRaw ? (
                    <span
                    className={Utils.getDescClass(item.outputLanguage2.desc)}
                    >{item.outputLanguage2.desc}</span>
                    ) : (
              <span
              className={Utils.getDescClass(item.outputLanguage2.desc)}
              dangerouslySetInnerHTML={{
                  __html: Utils.doPreview(item.outputLanguage2.desc),
              }}
              ></span>
                    )}
          </li>
      </ul>
        ) : null
        }
    </li>
  );
}

export default SkillResult;